import { Routes, RouterModule } from '@angular/router';
import { EinConfigurationScreenComponent } from './ein-configuration.component';

const einConfigurationRoutes: Routes = [
];

export const EinConfigurationRouter = RouterModule.forChild(einConfigurationRoutes);